<template>
  <div class="app_box">
    <el-menu :default-active="$route.name" class="el-menu-vertical-demo" background-color="#fff" text-color="#428bca"
      active-text-color="#fff" active-background-color="#333" router unique-opened>
      <template v-for="(menu,index) in menus">
        <el-menu-item class="boxa" v-if="menu.name2=='退出'" :index="menu.name" :route="{path:menu.path}" @click="exit">
          <span slot="title">{{menu.name2}}</span>
        </el-menu-item>
        <el-menu-item :index="menu.name" :route="{path:menu.path}" class="boxa" v-else>
          <span slot="title">{{menu.name2}}</span>
        </el-menu-item>
      </template>

    </el-menu>
  </div>
</template>

<script>
  import {
    loginOut
  } from '../api/api'
  import local from '../utils/local'
  export default {
    data() {
      return {
        menus: [{
            name: 'parameter',
            name2: '参数设置',
            path: '/home/parameter'
          },
          {
            name: 'case',
            name2: '案例展示',
            path: '/home/case'
          }, {
            name: 'team',
            name2: '我们的团队',
            path: '/home/team'
          }, {
            name: 'upload',
            name2: '图片上传',
            path: '/home/upload'
          }, {
            name: 'Administrator',
            name2: '管理员',
            path: '/home/Administrator'
          },
          {
            name2: '退出',
            name: 'exit',
            path: ''
          }
        ],

      };
    },
    methods: {
      exit() {
        let id = local.get('admin_id')
        loginOut(id).then(res => {
          console.log(res)
          if (res.data.status == 200) {
            local.remove("admin_id");
            this.$message({
              type: 'success',
              message: '退出成功'
            })
            this.$router.push('/login')

          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .el-menu {
    border: none !important;
  }

  .el-menu-item {
    border-radius: 10px;
    color: #fff;
  }

  .el-menu-item:hover {
    background-color: #428bca !important;
    border-radius: 10px;
    color: #fff !important;
  }

  .el-menu-item.is-active {
    background-color: #428bca !important;
    border-radius: 10px;
    color: #fff;

    span {
      color: #fff !important;
    }
  }
</style>